export default __webpack_public_path__ + "images/TROPOCEAN.e5ba6ab.png";